<template>

  <div class="position-relative">

    <!-- Invisible identify layer used to store feature for point intersect -->
    <ServiceAreasLayer v-if="features && features.length > 1"
                       ref="serviceAreasLayer"
                       :features="features"
                       color="transparent"
                       @layer-ready="handleLayerReady"
    ></ServiceAreasLayer>

    <!-- UI panel for identify results -->

    <l-control :position="panelLocation" v-if="useResultsPanel">
      <v-expand-transition>
        <IdentifyResultsPanel v-if="$store.state.data.identifyResults"
                              @close="clearIdentifyResults"
                              @point-zoom="centerOnIdentifyMarker"
                              @sa-identify-row-clicked="handleServiceAreaClicked"
        ></IdentifyResultsPanel>
      </v-expand-transition>
    </l-control>

  </div>

</template>

<script>
import orderBy from 'lodash/orderBy';
import { DomUtil } from 'leaflet';

import LayerMixin from './Layer.Mixin';
import ServiceAreasLayer from './ServiceAreasLayer';

import IdentifyResultsPanel from '@/components/map-components/IdentifyResultsPanel';

const name = 'IdentifyService';

export default {

  name,

  mixins: [LayerMixin],

  components: { IdentifyResultsPanel, ServiceAreasLayer, },

  props: {

    panelLocation: {
      type: String,
      required: false,
      default: 'bottomright',
    },

    useResultsPanel: {
      type: Boolean,
      required: false,
      default: true,
    },

  },

  data() {
    return {
      map: null,
      layer: null,
      open: false,
    };
  },

  mounted() {
    this.clearIdentifyResults();
  },

  watch: {

    features() {
      if (this.layer) {
        this.layer.bringToBack();
      }
    },

    identifyResults() {
      this.open = this.identifyResults;
    },

    '$store.state.mapping.identifyPoint'(latlng) {
      this.$store.dispatch('identifyLatLngInServiceAreas', latlng);
    },

  },

  computed: {

    features() {
      return this.$store.state.data.serviceAreas;
    },

    identifyResults() {
      return this.$store.state.data.identifyResults;
    },

  },

  methods: {

    identifyPoint({ latlng }) {
      DomUtil.addClass(this.map._container, 'cursor-progress');
      this.$store.dispatch('identifyLatLngInServiceAreas', latlng);
      DomUtil.removeClass(this.map._container, 'cursor-progress');
    },

    clearIdentifyResults() {
      this.$store.commit('SET_IDENTIFY_POINT', null);
      this.$store.commit('SET_IDENTIFY_RESULTS', null);
    },

    centerOnIdentifyMarker() {
      this.$emit('center-on-identify');
    },

    handleServiceAreaClicked(result) {
      this.$emit('provider-clicked', result);
      // this.$emit('identify-result-clicked', result);
    },

    handleLayerReady(layer) {
      this.map = layer._map;
      this.layer = layer;
    },

  },

};
</script>
